import type FetchService from '../FetchService';
import type { ApiRequestBodyType, ApiRequestPathParamType, ApiResponseType } from '../types';

class NotaryCertificationApi {
  private baseUrl = `/notary/certification`;

  constructor(protected fetchService: FetchService) {}

  getActivationToken() {
    return this.fetchService.get<ApiResponseType<'getActivationToken'>>(
      `${this.baseUrl}/plugin/token`,
    );
  }

  getHashToSign({ sessionId }: ApiRequestPathParamType<'getHashToSign'>) {
    return this.fetchService.get<ApiResponseType<'getHashToSign'>>(
      `${this.baseUrl}/signature/sessions/${sessionId}/hashToSign`,
    );
  }

  initiateSigningFlow(params: ApiRequestBodyType<'initiateSigningFlow'>) {
    return this.fetchService.post<ApiResponseType<'initiateSigningFlow'>>(
      `${this.baseUrl}/signature/sessions`,
      params,
      undefined,
      { resAsBlob: true, withResponseHeaders: true },
    );
  }

  validateCertificate(sessionId: string, params: ApiRequestBodyType<'validateCertificate'>) {
    return this.fetchService.post<ApiResponseType<'validateCertificate'>>(
      `${this.baseUrl}/signature/sessions/${sessionId}/certificateValidation`,
      params,
    );
  }

  sign(sessionId: string, params: ApiRequestBodyType<'sign'>) {
    return this.fetchService.post<ApiResponseType<'sign'>>(
      `${this.baseUrl}/signature/sessions/${sessionId}/sign`,
      params,
    );
  }
}

export default NotaryCertificationApi;
